<template>
  <v-container class="home" fluid mb-0>
    <v-layout row wrap>
      <span class="bg"></span>
      <v-flex
        pa-5
        xs12
        :md5="!panelFocus"
        :md10="panelFocus"
        offset-md1
        :lg4="!panelFocus"
        :lg8="panelFocus"
        offset-lg2
      >
        <v-card v-if="!panelFocus2" outline class="mx-auto">
          <v-system-bar color="#e60085" style="padding: 1.2em">
            <v-icon color="#fff">mdi-information-outline</v-icon>
            <span style="color: #fff; font-size:16px">Witamy</span>
          </v-system-bar>
          <v-card-text style="font-size: 16px">
            <p style="text-align:justify">
              <img src="/img/herb.jpg" class="float-left pr-2" width="50" />
              Witamy w serwisie przeznaczonym dla mieszkańców miasta Katowice,
              prezentującym wybrane informacje z Katowickiego Inteligentnego Systemu Monitoringu i Analizy (KISMiA).
              Serwis jest dostosowany do przeglądarek na urządzeniach stacjonarnych (komputery PC) oraz do
              przeglądarek na urządzeniach mobilnych, możliwe jest również zainstalowanie go jako aplikacji PWA.
            </p>
            <div style="clear:both"></div>
            <p class="mt-1">W serwisie można uzyskać informacje o:</p>
            <div>
              <ul>
                <li>aktualnym oraz prognozowanym poziomie stężeń zanieczyszczeń powietrza w obrębie miasta Katowice</li>
                <li>poziomie wody w wybranych, zagrożonych podtopieniami częściach miasta</li>
                <li>aktualnych oraz planowanych zdarzeniach i ich lokalizacjach</li>
              </ul>
            </div>

            <v-card-actions mt-0 pt-0>
              <v-btn text @click="show = !show; panelFocus=!panelFocus">Więcej</v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="show = !show; panelFocus=!panelFocus">
                <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>

            <v-expand-transition>
              <div v-show="show">
                <v-divider></v-divider>

                <v-card-text style="font-size: 16px">
                  <p style="text-align:justify">
                    Informacje prezentowane są na mapie w formie graficznej
                    w postaci kart z informacjami oraz na podkładzie mapy,
                    której wizualizacja pozwala użytkownikowi na obserwację
                    wybranego obszaru za pomocą intuicyjnych metod interakcji
                    oraz kodu kolorów.
                  </p>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        pa-5
        xs12
        :md5="!panelFocus2"
        :md10="panelFocus2"
        :offset-md1="panelFocus2"
        :lg4="!panelFocus2"
        :lg8="panelFocus2"
        :offset-lg2="panelFocus2"
      >
        <v-card v-if="!panelFocus" outline class="mx-auto">
          <v-system-bar color="#e60085" style="padding: 1.2em">
            <v-icon color="#fff">mdi-message</v-icon>
            <span style="color: #fff; font-size:16px">Jak korzystać z platformy</span>
            <v-spacer></v-spacer>
          </v-system-bar>
          <v-card-text style="font-size: 16px">
            <p style="text-align:justify;text-indent: 35px">
              Przy pierwszym wejściu do serwisu wyświetlane są informacje o przeznaczeniu i
              funkcji serwisu oraz o tym, jak z niego korzystać.
              W ramach struktury serwisu dostępne są następujące opcje menu głównego:
              Komunikaty, Jakość powietrza, Poziom wód oraz Informacje statyczne. Kliknięcie
              na ikonę loga Katowic w lewym górnym rogu, powoduje przeniesienie na strone startową.
            </p>
            <p style="text-align:justify;text-indent: 35px">
              W poszczególnych zakładkach uzyskujemy informacje na temat aktualnych oraz
              planowanych zdarzeń w mieście (zwłaszcza zdarzeń związanych z utrudnieniami
              w ruchu oraz imprezami masowymi), o aktualnym oraz prognozowanym poziomie
              stężenia zanieczyszczenia powietrza oraz poziomie wody w wybranych,
              krytycznych punktach ,najbardziej zagrożonych podtopieniami.
            </p>
            <v-card-actions mt-0 pt-0>
              <v-btn text @click="show2 = !show2; panelFocus2=!panelFocus2">Więcej</v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="show2 = !show2; panelFocus2=!panelFocus2">
                <v-icon>{{ show2 ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </v-btn>
            </v-card-actions>
            <v-expand-transition>
              <div v-show="show2">
                <v-divider></v-divider>
                <v-card-text style="font-size: 16px">
                  <p class="text-justify">
                    <v-icon color="#8c0d6e" class="pr-2">mdi-message-text-outline</v-icon>W zakładce Komunikaty, jeżeli pod informacją wyświetlany jest przycisk Szczegóły,
                    możemy poprzez jego kliknięcie przenieść się na stronę danego zdarzenia a poprzez
                    kliknięcie przycisku Mapa, przenieść się bezpośrednio do zakładki: Informacje statyczne,
                    gdyż oznacza to, że zdarzenie związane jest z lokalizacją na terenie miasta.
                  </p>
                  <p class="text-justify">
                    <v-icon color="#94a60d" class="pr-2">mdi-weather-windy</v-icon>W zakładce Jakość powietrza wyświetlane są wartości zanieczyszczenia powietrza .
                    Skala barw ikon, reprezentujących czujniki (od zielonego do czerwonego), informuje o
                    aktualnych poziomach zanieczyszczeń. Widżet Legenda pokazuje szczegółowe objaśnienia
                    wartości zanieczyszczeń dla poszczególnych barw. Dodatkowo poprzez kliknięcie na ikonę
                    danego czujnika możemy wyświetlić kartę, zawierającą szczegółowe informacje na temat pomiarów
                  </p>
                  <p class="text-justify">
                    <v-icon color="#45a3c2" class="pr-2">mdi-weather-sunset</v-icon>Analogicznie do zakładki Jakość powietrza, działa zakładka Poziom wód, obrazująca za pomocą
                    skali barw poziom wody dla danego czujnika podtopień oraz kartę szczegółowych informacji, po kliknięciu
                    na ikonę czujnika
                  </p>
                  <p class="text-justify">
                    <v-icon color="#bd0512" class="pr-2">mdi-sign-caution</v-icon>W zakładce Informacje statyczne na podkładzie mapy widzimy informacje o zdarzeniach oraz ich
                    rodzajach na terenie miasta Katowice. Możemy rozróżnić zdarzenia aktualne oraz planowane,
                    które oznaczone są ikoną na niebieskim podkładzie. Mamy możliwość filtrowania typu zdarzenia
                    oraz prezentowania zdarzeń przyszłych za pomocą panelu Legenda. Aktualnie wyświetlane są następujące
                    typy zdarzeń: Remont/Przebudowa/Usuwanie awarii/Impreza masowa/Zmiany w organizacji ruchu.
                  </p>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: "home",
  components: {},
  data: () => ({
    show: false,
    show2: false,
    panelFocus2: false,
    panelFocus: false
  }),
  computed: {
    currentTime() {
      var today = new Date();
      var time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return time;
    }
  },
  methods: {}
};
</script>
<style scoped>
.home {
  margin-top: 16em;
}
.bg {
  width: 100%;
  height: 20em;
  position: absolute;
  top: 0;
  left: 0;
  background: url("/img/katowice1.jpg") no-repeat center center;
  background-size: cover;
  transform: scale(1.1);
}

.mdi-chevron-down::before {
  background: url("/img/down.png") no-repeat center center;
  width: 16px;
  height: 8px;
  content: "";
}

.mdi-chevron-up::before {
  background: url("/img/up.png") no-repeat center center;
  width: 16px;
  height: 8px;
  content: "";
}
</style>